firebird.factory('canvasMonitoringService', [
    '$rootScope',
    '$window',
    '$interval',
    'analyticsWrapperService',
    'logService',
    function ($rootScope, $window, $interval, analyticsWrapperService, logService) {
        var isMonitoring = false;
        var videoFeed;
        var canvasArea;
        var annotationSurface;
        var canvasSizeInterval;
        var shadowExpanded = false;
        var shadowFullScreen = false;
        var annotationInSession = false;

        var service = {
            setFullScreenState: setFullScreenState,
            setExpandedState: setExpandedState,
            startCanvasMonitor: startCanvasMonitor,
            stopCanvasMonitor: stopCanvasMonitor,
            setAnnotationInSession: setAnnotationInSession
        };

        return service;

        ////////////////////////
        function setAnnotationInSession(inSession) {
            annotationInSession = inSession;
        }

        function setFullScreenState(flag) {
            shadowFullScreen = flag;
        }

        function setExpandedState(flag) {
            shadowExpanded = flag;
        }

        function stopCanvasMonitor() {
            if (annotationInSession) {
                logService.log('annotation still in session');
                return;
            }

            logService.log('calling stopCanvasMonitor ...');

            if (videoFeed) {
                videoFeed.css('max-width', '');
                videoFeed.css('max-height', '');
            }

            if (canvasSizeInterval) {
                $interval.cancel(canvasSizeInterval);
            }

            isMonitoring = false;
        }

        function startCanvasMonitor(contentService, videoFeedElement, canvasAreaElement, annotationSurfaceElement) {
            if (isMonitoring) {
                return;
            }

            logService.log('calling startCanvasMonitor ...');

            videoFeed = videoFeedElement;
            canvasArea = canvasAreaElement;
            annotationSurface = annotationSurfaceElement;

            var oldRatio = 0;
            var oldDimensions;
            var oldCanvasDimensions;
            var oldMaximizedStatus = contentService.isContentMaximized();

            //Watch for changes on window resize
            canvasSizeInterval = $interval(function () {
                var changeDetected;

                if (videoFeed[0].videoHeight > 0) {
                    var newRatio = videoFeed[0].videoWidth / videoFeed[0].videoHeight;
                    if (newRatio != oldRatio) {
                        changeDetected = true;
                        oldRatio = newRatio;
                    }
                }

                var fullScreen = shadowFullScreen;
                var isExpanded = shadowExpanded;

                //Content Maximized
                var newMaximizedStatus = contentService.isContentMaximized();

                if (oldMaximizedStatus !== newMaximizedStatus) {
                    oldMaximizedStatus = newMaximizedStatus;
                    changeDetected = true;
                }

                //Dimensions
                var feedCoverWidth = videoFeed[0].offsetWidth;
                var feedCoverHeight = videoFeed[0].offsetHeight;
                var canvasCoverWidth = canvasArea[0].offsetWidth;
                var canvasCoverHeight = canvasArea[0].offsetHeight;

                //canvas maxed at 1920 x 1080
                if (!isExpanded && !fullScreen) {
                    if (canvasCoverWidth > 1920) {
                        canvasCoverWidth = 1920;
                    }

                    if (canvasCoverHeight > 1080) {
                        canvasCoverHeight = 1080;
                    }
                }

                //if the canvas dimension is bigger , then use the canvas dimensions as the feed dimensions and the adjustment below will take care of it
                if (canvasCoverWidth > feedCoverWidth || !isExpanded) {
                    feedCoverWidth = canvasCoverWidth;
                    feedCoverHeight = canvasCoverHeight;
                }

                var newDimensions = feedCoverWidth + 'x' + feedCoverHeight;
                var newCanvasDimensions = canvasCoverWidth + 'x' + canvasCoverHeight;

                if (oldDimensions !== newDimensions || oldCanvasDimensions !== newCanvasDimensions) {
                    oldDimensions = newDimensions;
                    oldCanvasDimensions = newCanvasDimensions;
                    changeDetected = true;
                }

                //Update cover resolution
                if (changeDetected) {
                    // use ratio from  actual video feed above
                    // in above block, a max will be placed on the values
                    // calculate the dimension from ratio on the actual dimensions
                    // one at container width and the other calculated from ratio

                    var containedWidthOfVideo;
                    var containedHeightOfVideo;

                    if (oldRatio <= 0) {
                        // this happens when monitoring begins but the stream is not fully initialized
                        // and does not contain size
                        return;
                    }

                    if (feedCoverWidth / feedCoverHeight < oldRatio) {
                        containedWidthOfVideo = feedCoverWidth;
                        containedHeightOfVideo = Math.floor(feedCoverWidth / oldRatio);
                    } else {
                        containedHeightOfVideo = feedCoverHeight;
                        containedWidthOfVideo = Math.floor(feedCoverHeight * oldRatio);
                    }

                    newDimensions = containedWidthOfVideo + 'x' + containedHeightOfVideo;
                    oldDimensions = newDimensions;

                    videoFeed.css('max-width', containedWidthOfVideo + 'px');
                    videoFeed.css('max-height', containedHeightOfVideo + 'px');

                    if (annotationSurface) {
                        annotationSurface.css('max-width', containedWidthOfVideo + 'px');
                        annotationSurface.css('max-height', containedHeightOfVideo + 'px');
                        annotationSurface.css('width', containedWidthOfVideo + 'px');
                        annotationSurface.css('height', containedHeightOfVideo + 'px');

                        if ($window.paper.view) {
                            $window.paper.view.setViewSize(containedWidthOfVideo, containedHeightOfVideo);
                        }
                    }
                }
            }, 100);

            isMonitoring = true;
        }
    }
]);
